import { render, staticRenderFns } from "./levelEdit.vue?vue&type=template&id=0253bee0&scoped=true"
import script from "./levelEdit.vue?vue&type=script&lang=js"
export * from "./levelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0253bee0",
  null
  
)

export default component.exports